export function index()
{
    return axios.get(
        route('api.manage.companies.filters.jobs')
    ).then(response => response.data);
}
